export default "__VITE_ASSET__Dpp1Km9n__"